import { createBrowserRouter, createMemoryRouter } from 'react-router-dom'
import loadable from '@loadable/component'
import { App } from './App'
import ScreensRouter from './components/ScreensRouter/ScreensRouter'
import { Screens } from 'patient-api-lib'

const DemoPage = loadable(() => import('./components/DemoPage/DemoPage'))
const TreatmentScreen = loadable(
  () => import('./screens/TreatmentScreen/TreatmentScreen')
)
const CityScreen = loadable(() => import('./screens/CityScreen/CityScreen'))
const ClinicScreen = loadable(
  () => import('./screens/ClinicScreen/ClinicScreen')
)
const AppointmentScreen = loadable(
  () => import('./screens/AppointmentScreen/AppointmentScreen')
)
const BookingSummaryScreen = loadable(
  () => import('./screens/BookingSummaryScreen/BookingSummaryScreen')
)
const ContactInformationScreen = loadable(
  () => import('./screens/ContactInformationScreen/ContactInformationScreen')
)
const BookingContactScreen = loadable(
  () =>
    import('./screens/ContactInformationScreen/BookingContactInformationScreen')
)
const BookingConfirmationScreen = loadable(
  () => import('./screens/BookingConfirmationScreen/BookingConfirmationScreen')
)
const MyBookingsScreen = loadable(
  () => import('./screens/MyBookings/MyBookings')
)
const YourBookingsScreen = loadable(
  () => import('./screens/YourBookings/YourBookings')
)
const BookingDetailsScreen = loadable(
  () => import('./screens/BookingDetails/BookingDetails')
)
const TreatmentSelectionScreen = loadable(
  () => import('./screens/TreatmentScreen/TreatmentSelection')
)
const TokenizationScreen = loadable(
  () => import('./screens/TokenizationScreen/TokenizationScreen')
)

export const routes = [
  {
    path: `/`,
    element: <App />,
    children: [
      {
        path: `/booking`,
        element: <ScreensRouter />,
        children: [
          {
            path: Screens.TreatmentScreen,
            element: <TreatmentScreen />,
          },
          {
            path: Screens.TreatmentSelectionScreen,
            element: <TreatmentSelectionScreen />,
          },
          {
            path: Screens.CityScreen,
            element: <CityScreen />,
          },
          {
            path: Screens.ClinicScreen,
            element: <ClinicScreen />,
          },
          {
            path: Screens.AppointmentScreen,
            element: <AppointmentScreen />,
          },
          {
            path: Screens.BookingSummaryScreen,
            element: <BookingSummaryScreen />,
          },
          {
            path: Screens.BookingContactScreen,
            element: <BookingContactScreen />,
          },
          {
            path: Screens.ContactInformationScreen,
            element: <ContactInformationScreen />,
          },
          {
            path: Screens.TokenizationScreen,
            element: <TokenizationScreen />,
          },
          {
            path: Screens.BookingConfirmationScreen,
            element: <BookingConfirmationScreen />,
          },
          {
            path: Screens.MyBookingsScreen,
            element: <MyBookingsScreen />,
          },
          {
            path: Screens.YourBookingsScreen,
            element: <YourBookingsScreen />,
          },
          {
            path: Screens.BookingDetailsScreen,
            element: <BookingDetailsScreen />,
          },
        ],
      },
      {
        path: `/demo`,
        element: <DemoPage />,
      },
    ],
  },
]

export const mockRouter = createMemoryRouter(routes, {
  initialEntries: ['/v2/booking/'],
  basename: '/v2',
  initialIndex: 0,
})

export const router = createBrowserRouter(routes, {
  basename: '/v2/',
})
